
define("json!datas/routes.json", function(){ return {
    "API_BASE_URL": "api/<%= iso_lang %>/",

    "app": "app",

    "apiSetupModel": "setup",
    "apiSetupPrivateModel": "setupprivate",

    "apiCategoryCollection": "category",
    "apiCategoryModel": "category/<%= id_category %>",

    "apiConfigurationCollection": "configuration",

    "apiCountryCollection": "country",
    "apiCountryModel": "country/<%= id_country %>",

    "apiMacaronCollection": "macaron",
    "apiMacaronModel": "macaron/<%= id_macaron %>",

    "apiPaymentMethodCollection": "paymentmethod",
    "apiPaymentMethodModel": "paymentmethod/<%= id_payment_method %>",

    "apiPostcodeCollection": "postcode",
    "apiPostcodeModel": "postcode/<%= id_postcode %>",
    "apiPostcodeSubscribe": "postcode/<%= postcode %>/subscribe",

    "apiProductCollection": "product",
    "apiProductModel": "product/<%= id_product %>",

    "apiStoreCollection": "store",
    "apiStoreModel": "store/<%= id_store %>",
    "apiStoreClosure": "storeclosure/<%= id_store %>",

    "apiStoreServiceCollection": "storeservice",
    "apiStoreServiceModel": "storeservice/<%= id_store_service %>",
    "apiJob": "jobs",
    "apiWidgetJob": "jobwidget",
    "apiTranslationModel": "translation",
    "apiLoginFacebook": "signin/facebook",
    "apiLoginGoogle": "signin/google",
    "apiLogin": "signin",
    "apiLogout": "signout",
    "apiRegisterNewsLetter": "customer/new/registernewsletter",
    "apiRegister": "customer/new/add",
    "apiAdvantageModel": "advantagewidget/<%= id_widget_instance %>",
    "apiIngredientCollection": "ingredient",
    "apiIngredientModel": "ingredient/<%= id_ingredient %>",

    "apiAdvancedTemplatingWidget": "advancedtemplatingwidget/<%= ressource %>",

    "apiTagCollection": "tag",
    "apiTagModel": "tag/<%= id_ingredient %>",

    "apiUniversalLinkCollection": "universallink",

    "apiErrorModel": "error",

    "apiAllergenGroupCollection": "allergengroup",
    "apiAllergenGroupModel": "allergengroup/<%= id_allergen_group %>",
    "apiEstimatedTime": "estimatedtime",

    "apiCustomerPasswordUpdate": "customer/current/password",
    "apiCustomerNeolaneComein": "neolane/signup/validation",
    "apiCustomerModel": "customer/current",
    "apiCustomerModelComein": "customer/current/comein",
    "apiCustomersetSmsAlert": "customer/current/setsmsalert",
    "apiCustomersetMailAlert": "customer/current/setmailalert",
    "apiCustomersetNewsletter": "customer/current/setnewsletter",
    "apiCustomerLikeProduct": "customer/current/likeproduct",
    "apiCustomerRemoveCard": "customer/current/removecard",
    "apiCustomersetResetPassword": "customer/current/resetpassword",
    "apiCustomerSponsorshipSendByEmail": "customer/current/sponsorshipsendbyemail",
    "apiCartModel": "cart/<%= id_cart %>",
    "apiCartSet": "cart/<%= id_cart %>/set",
    "apiCartDeliveryOptions": "cart/<%= id_cart %>/deliveryoptions",
    "apiCartProductCollection": "cart/<%= id_cart %>/product",
    "apiCartMultipleProductCollection": "cart/<%= id_cart %>/multipleproduct",
    "apiCartProductModel": "cart/<%= id_cart %>/product/<%= id_product %>",
    "apiCartAddProduct": "cart/<%= id_cart %>/add",
    "apiCartDeleteProduct": "cart/<%= id_cart %>/remove",
    "apiCartPostcode": "cart/<%= id_cart %>/postcode",
    "apiCartDatetime": "cart/<%= id_cart %>/datetime",
    "apiCartStore": "cart/<%= id_cart %>/store",
    "apiCartConsumableReset": "cart/<%= id_cart %>/resetpreset",
    "apiCartConsumableOptions": "cart/<%= id_cart %>/consumable",
    "apiCartVoucherAdd": "cart/<%= id_cart %>/discount",
    "apiCartSetProductLikeOffered": "cart/<%= id_cart %>/discountfreeproduct",
    "apiCartVoucherRemove": "cart/<%= id_cart %>/discount/remove",
    "apiContactModel": "contact/<%= id_contact %>",
    "apiContactCollection": "contact",
    "apiCartSideDishAdd": "cart/<%= id_cart %>/sidedish",
    "apiCartReorder": "cart/<%= id_cart %>/reorder/<%= id_parent_cart %>",
    "apiCartAddToCart": "cart/<%= id_cart %>/addtocart/<%= id_parent_cart %>",
    "apiCartSetCurrent": "cart/<%= id_cart %>/setcurrent",
    "apiCartCagnotte": "cart/<%= id_cart %>/cagnotte",
    "apiZendeskSendContact": "zendeskcontact<%= params %>",
    "apiArticleSupportModel": "zendeskarticles/<%= id %>",
    "apiArticleSupportCollection": "zendeskarticles",
    "apiZendeskarticles": "zendeskarticles",
    "apiZendesksections": "zendesksection",
    "apiZendeskcategory": "zendeskcategory",

    "apiZendeskfields": "zendeskfield",
    "apiZendeskforms": "zendeskform",

    "apiZendeskBundle": "zendeskbundle",
    "apiZendeskArticle": "zendeskarticle",
    "apiZendeskSection": "zendesksection",
    "apiZendeskCategory": "zendeskcategory",
    "apiZendeskField": "zendeskfield",
    "apiZendeskForm": "zendeskform",

    "apiOrderCollection": "order",
    "apiOrderModel": "order/<%= id_order %>",
    "apiOrderFromCart": "order/<%= id_cart %>/cart",
    "apiOrderValidate": "order/<%= id_cart %>/orderpayed",
    "apiOrderPending": "orderpending/<%= payment_action_id %>/<%= action %>",

    "apiToolsPaymentMethod": "toolspayment/<%= method %>",
    "apiEdenredData": "toolspayment/getEdenredData",
    "apiEdenredLogout": "toolspayment/logoutEdenred",

    "apiAddressCollection": "address",
    "apiAddressModel": "address/<%= id_address %>",

    "apiPlaceModel": "place/<%= place_id %>/estimations/<%= base64address %>",

    "apiWidgetGroupCollection": "widgetgroup",
    "apiWidgetGroupModel": "widgetgroup/<%= id_widget_group %>",
    "apiWidgetLayoutFormatCollection": "widgetlayoutformat",
    "apiWidgetLayoutFormatModel": "widgetlayoutformat/<%= id_widget_layout_format %>",
    "apiWidgetCollectionCollection": "widgetcollection",
    "apiWidgetCollectionModel": "widgetcollection/<%= id_widget_collection %>",
    "apiWidgetInstanceCollection": "widgetinstance",
    "apiWidgetInstanceModel": "widgetinstance/<%= id_widget_instance %>",

    "apiSyncModel": "sync",

    "apiMessageCollection": "sushimessage",
    "apiStoreAvisVerifie": "avisverifie/store/<%= id_store %>?<%= stars ? 'stars='+stars : '' %>",
    "apiStoreMessageCollection": "storemessage/<%= id_store %>",
    "apiStockoutProductModel": "stockoutproduct/<%= id_store %>",
    "apiStoreLocatorSearch": "storelocatorsearch?search=<%= search %>",
    "apiStoreLocatorSearchCollection": "storelocatorsearch?search=<%= search %>",

    "apiStoreLocatorBundle": "storelocatorbundle/",
    "apiStateCollection": "<%= c('_STORE_BASE_URL_') +'/'+ store_rewrite %>",

    "picture": "<%= model +'-'+ id_picture +'-'+ suffix +'/'+ rewrite +'.'+ extension %>",

    "gui": "gui",

    "home": "",

    "logout": "<%= c('_LOGOUT_REWRITE_') %>",

    "accountDashboard": "<%= c('_ACCOUNT_BASE_URL_') %>",
    "accountLink": "<%= c('_ACCOUNT_BASE_URL_') +'/'+ c('_ACCOUNT_LOYALTY_REWRITE_') %>",
    "accountOrders": "<%= c('_ACCOUNT_BASE_URL_') +'/'+ c('_ACCOUNT_ORDERS_REWRITE_') %>",
    "accountPage": "<%= c('_ACCOUNT_BASE_URL_') +'/'+ account_rewrite %>",

    "reorder": "<%= c('_PAGE_REORDER_BASE_URL_') %>",

    "cart": "<%= c('_CHECKOUT_BASE_URL_') %>/<%= c('_CART_BASE_URL_') %>",
    "checkout": "<%= c('_CHECKOUT_BASE_URL_') %>",
    "checkoutOpc": "<%= c('_CHECKOUT_BASE_URL_') %>/<%= rewrite %>",
    "product": "<%= c('_CATEGORY_BASE_URL_') +'/'+ category_link_rewrite %>/<%= product_link_rewrite %>-<%= id_product %>",
    "authentification": "<%= c('_AUTHENTIFICATION_BASE_URL_') %>",
    "supportCenter": "<%= c('_SUPPORT_CENTER_BASE_URL_') %>",
    "supportCenterResource": "<%= c('_SUPPORT_CENTER_BASE_URL_') + '/' + type + '-' + id %>",
    "supportCenterSearch": "<%= c('_SUPPORT_CENTER_BASE_URL_') + '/' + type %>",
    "supportCenterSection": "<%= c('_SUPPORT_CENTER_BASE_URL_') +'/'+ section_rewrite %>",
    "recruitment": "<%= c('_RECRUITMENT_URL_') %>",

    "widgetGroup": "<%= widget_group_rewrite %>",

    "stores": "<%= c('_STORES_BASE_URL_') %>",
    "storeLocatorSearch": "<%= c('_STORES_BASE_URL_') %>/<%= search %>",
    "storeLocatorState": "<%= c('_STORES_BASE_URL_') %>/<%= c('_STORELOC_STATE_PREFIX_', 'r') %>/<%= state %>",
    "storeLocatorPosition": "<%= c('_STORES_BASE_URL_') %>/<%= c('_STORELOC_POSITION_PREFIX_','pos') %>/<%= lat %>_<%= lng %>",
    "storeLocatorBounds": "<%= c('_STORES_BASE_URL_') %>/<%= c('_STORELOC_BOUNDS_PREFIX_','bounds') %>/<%= bounds %>",
    "storeLocatorPostcode": "<%= c('_STORES_BASE_URL_') %>/<%= city %>/<%= postcode %>",
    "storeLocatorShop": "<%= c('_STORES_BASE_URL_') %>/<%= c('_STORELOC_SHOP_PREFIX_', 's') %>/<%= shop %>",
    "store": "<%= c('_STORE_BASE_URL_') +'/'+ store_rewrite %>",

    "kei": "<%= c('_KEI_URL_') %>",
    "carte2017": "<%= c('_CARTE_2017_URL_') %>",

    "newsHome": "<%= c('_PAGE_NEWS_BASE_URL_') %>",
    "newsFlag": "<%= c('_PAGE_NEWS_BASE_URL_') %>/flag/<%= url_rewrite %>",
    "newsSingle": "<%= c('_PAGE_NEWS_BASE_URL_') %>/<%= url_rewrite %>",

    "category": "<%= c('_CATEGORY_BASE_URL_') +'/'+ category_link_rewrite %>",
    "allCategories": "<%= c('_ALL_CATEGORIES_BASE_URL_') %>",

    "webapps-action": "webapps-action/<%= action %>/",
    "webapps-action-product": "webapps-action/<%= action %>/<%= id_product %>/<%= option %>",
    "webapps-action-redirect-category": "webapps-action/redirect/category",

    "video": "USER/video/exports/<%= id_video %>.<%= size %>.<%= type %>.<%= format %>",
    "videoHD": "USER/video/HD/<%= id_video %>.mp4",

    "tc_vars": "FRONTOFFICE/ajax/tc_vars.js.php?contentType=json&",
    "tc_url": "<%= c('_TAGCOMMANDERURLFOOTER_') %>",

    "googlePlacesAPIAutocomplete": "https://maps.googleapis.com/maps/api/place/autocomplete/json?<%= params %>&key=AIzaSyDh7EIKHic3C2vXpw0IwWq471DX0TEmJgI"
}
;});

